export const environment = {
    openReplayEnabled: true,
    openReplayApplication: 'teki-web',
    openReplayProjectKey: 'NmUGB4c8dHy2tTqNX5FF',
    glitchTipDsn: 'https://dc6a5b66007249f8be715a6d7a2f4547@glitchtip.cbetcloud.com/5',
    glitchTipEnvironment: 'production',
    production: true,
    endpointApi: 'https://api.teki.pe/api',
    iaEndpoint: 'https://ai.teki.pe/ai',
    shareMenuUrl: 'https://menu.teki.pe',
    // Base publica de la carta QR. Vacio = mismo origen que el POS, que es
    // lo correcto en los entornos donde CloudFront enruta /carta* al SSR.
    // En local los dos apps viven en puertos distintos, por eso se apunta al SSR.
    cartaBaseUrl: '',
    shareCatalogoUrl: 'https://catalogo.teki.pe',
    urlLogo: 'assets/layout/images/logo-mirage@2x.png',
    wsEndpoint: 'https://sock.teki.pe',
    wsEndpointPrint: 'https://sock.teki.pe',
    // Instaladores del servicio de impresión por sistema (siempre la última versión; los publica el CI de printer-service)
    printerInstallers: {
        windows: 'https://tekistorage.s3.us-east-1.amazonaws.com/impresion/ServicioImpresion-Teki.exe',
        macArm64: 'https://tekistorage.s3.us-east-1.amazonaws.com/impresion/ServicioImpresion-Teki-mac-arm64.pkg',
        macX64: 'https://tekistorage.s3.us-east-1.amazonaws.com/impresion/ServicioImpresion-Teki-mac-x64.pkg',
        linux: 'https://tekistorage.s3.us-east-1.amazonaws.com/impresion/ServicioImpresion-Teki-linux-amd64.deb'
    },
    balanzaEndpoint: 'http://127.0.0.1:9292',
    reconnectInterval: 2000,
    company: 'Teki',
    whatsappSoporte: '51976967870',
    maxDateRangeMonths: 3
};
